import { PdfData } from "@/models/pdfData";
import { AppSettings } from "@context/AppContext";
import { ActionHistoryResponseData } from "@/models/socketIo/socketIo";

interface LocalStorageModel {
  games: { games: PdfData[]; version: number };
  settings: AppSettings;
  actionBookmarks: {
    version: number;
    actionBookmarksByGame: { [key in string]: number[] };
  };
  actionHistory: { [key in string]: ActionHistoryResponseData };
}

export const getFromLocalStorage = <T extends keyof LocalStorageModel>(
  key: T,
): LocalStorageModel[T] | null => {
  const item = localStorage.getItem(key);
  if (item) {
    return JSON.parse(item);
  } else {
    return null;
  }
};

export const putToLocalStorage = <T extends keyof LocalStorageModel>(
  key: T,
  value: LocalStorageModel[T],
): void => {
  localStorage.setItem(key, JSON.stringify(value));
};
